/** The router's faux cell name, useful for treating it like a cell in Riveter */
export const routerCellName = 'router';

export const getLegacyApiUrl = (template: string) => {
  return template.replace('::CELL_NAME::.', '');
};

export const getCellApiUrl = (
  environment: string,
  cell: string,
  template: string,
) => {
  switch (environment) {
    case 'local':
      switch (cell) {
        case 'a':
          return template;
        case 'b':
          return template.replace('4001', '4003');
        case routerCellName:
          throw new Error(
            `Tried to get API URL for cell "${routerCellName}" aka \`routerCellName\`.
Some code is likely missing a conditional so when \`cell === routerCellName\`,
it only makes API requests to the router, since no real cell is set.

You may need to do some digging to find it since Observables mangle the stacktrace.
I recommend starting by:
* client/src/api/cell.ts:CellUrlInterceptor.intercept() - Add \`console.log('intercept', req.urlWithParams)\` inside
* client/src/api/cell.ts:AdminCellApiTranslator.replaceUrl() - Add \`console.log('replaceUrl', url)\` inside
* client/src/api/cell.ts:CellStore.getCellUrl() - See if you've touched anything that gets this manually`,
          );
        default:
          throw new Error(
            `Tried to get API URL for cell "${cell}" (can only use "a" or "b" on local)`,
          );
      }
    default:
      return template.replace('::CELL_NAME::', cell);
  }
};

export const isValidCellUrl = (
  environment: string,
  template: string,
  url: string,
) => {
  switch (environment) {
    case 'local':
      return (
        url.startsWith(template.split('4001')[0]) &&
        url.includes(template.split('4001')[1])
      );
    default:
      return (
        url.startsWith(template.split('::CELL_NAME::')[0]) &&
        (url.includes(template.split('::CELL_NAME::')[1]) ?? '')
      );
  }
};
